import { Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { escolaridadeKeyToLabel, IEscolaridade } from "../../../../../../../application/models";
// Icon
import SchoolIcon from '@mui/icons-material/School';

export const RecorteEscolaridadeFilterPreview = (props: {
    escolaridadeFilter?: IEscolaridade[]
}) => {

    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2} p={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Escolaridade
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Stack
                            direction="row"
                            flexWrap="wrap"
                        >
                            {props.escolaridadeFilter && props.escolaridadeFilter.map((escolaridade, i) => (
                                <Chip
                                    key={i}
                                    icon={<SchoolIcon />}
                                    label={escolaridadeKeyToLabel(escolaridade).toUpperCase()}
                                    sx={{
                                        m: 0.5
                                    }}
                                />
                            ))}
                        </Stack>
                    </Grid>
                </Paper>
            </Grid>
        </>
    )
}